import React, { useEffect } from "react";
import { features } from "../features";

export default function ScrollProgress() {
  useEffect(() => {
    if (!features.aiwaveMotion) return;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollY / documentHeight) * 100;
      document.documentElement.style.setProperty("--scroll", `${scrollPercent}%`);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Initial call

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!features.aiwaveMotion) {
    return null;
  }

  return (
    <div className="fixed left-0 top-0 h-[3px] z-50 w-full">
      <div 
        className="h-full shimmer-bg animate-shimmer" 
        style={{ width: "var(--scroll)" }}
      />
    </div>
  );
} 